module.exports = __webpack_public_path__ + "static/Mittelrhein1-scaled-ca8bf66f89a29a1a46f9c03a02622742.jpeg";